import { initializeApp } from 'firebase/app';
const firebaseConfig = {
    storageBucket: 'gs://every-single-street-pwm.appspot.com/',
};
const app = initializeApp(firebaseConfig);
export default app;
